<div class="overlay" #overlay (click)="onOverlayClick($event)">
    <div class="overlay__content">
        <div
            #uploadBox
            class="overlay__upload-box"
            (click)="$event.stopPropagation()"
            [class.dragover]="isDragOver"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
        >
            <p class="overlay__text">Drag and drop file here to upload</p>
            <img class="overlay__upload-icon" src="/assets/icons/upload-icon.svg" alt="" />
            <button class="overlay__button" (click)="triggerFileInput()">Choose a File</button>
            <input
                #fileInput
                type="file"
                hidden
                (change)="onFileSelected($event)"
                [accept]="fileUploadConfig.fileTypes"
            />
        </div>
    </div>
</div>
